import { render, staticRenderFns } from "./SalePdf.vue?vue&type=template&id=172084fb&"
import script from "./SalePdf.vue?vue&type=script&lang=js&"
export * from "./SalePdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports